define("Modules/Collapsible", [`Module`, `module`], (Super, Self) => {
	return Super.inherit({
		namespace: Self.id,
		defaults: {
			size: `normal`,
			class: null,
		},
		constructor(setup) {
			this.assign(this.data, {
				content: setup.content,
				class: setup.class,
				size: setup.size,
				expandable: false,
				expanded: false,
				buttonTheme: setup.theme === `DARK` ? `WHITE-OUTLINE` : `BLACK-OUTLINE`,
			});

			if (this.isString(setup.content, 1)) {
				this.render();

				switch (setup.size) {
					case `large`:
						this.addClass(`collapsible-large`);
						break;
					case `small`:
						this.addClass(`collapsible-small`);
						break;
				}
			} else {
				this.render({
					target: setup.container,
					append: true,
				});
			}

			this.update();
		},
		api: {
			update: {
				value() {
					var data = this.data,
						element,
						height,
						styles,
						maxHeight;

					if (data.expandable) {
						// was already big enough to expand in the past, ignore
						return;
					}

					element = this.get(`.content`);
					height = element.scrollHeight;
					styles = window.getComputedStyle(element);
					maxHeight = styles.getPropertyValue(`max-height`);

					maxHeight = maxHeight.replace(`px`, ``);
					maxHeight = parseInt(maxHeight, 10);

					if (this.isFinite(height, 1) && this.isFinite(maxHeight, 1)) {
						if (height > maxHeight) {
							if (!this.hasClass(`collapsed`) && !this.hasClass(`expanded`)) {
								this.addClass(`expandable collapsed`);
								data.expandable = true;
							}
						}
					} else {
						// no good style values found, retry
						this.defer({
							duration: 500,
							then: this.update,
							done: true,
						});
					}
				},
			},
		},
		listeners: [
			{
				event: `click`,
				filter: `[action="toggle"]`,
				handler(evt) {
					if (this.data.expanded) {
						this.removeClass(`expanded`);
						this.addClass(`collapsed`);
					} else {
						this.removeClass(`collapsed`);
						this.addClass(`expanded`);
					}

					this.data.expanded = !this.data.expanded;

					// TODO: Uncomment when scrollTo default target issue is fixed in site-builder
					// this.App.scrollTo({ buffer: 170 });
				},
			},
			{
				event: `resize`,
				target: window,
				handler(evt) {
					this.update();
				},
			},
		],
	});
});

define("Modules/Collapsible.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Modules/Collapsible/main"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"content"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"class") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":34},"end":{"line":1,"column":64}}})) != null ? stack1 : "")
    + "\">"
    + ((stack1 = container.lambda((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0)) != null ? stack1 : "")
    + "</div>";
},"2":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"class") : depth0), depth0));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"content") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":92}}})) != null ? stack1 : "")
    + " <a href=\"#\" action=\"toggle\" class=\"button small left-align\" theme=\""
    + alias2(container.lambda((depth0 != null ? lookupProperty(depth0,"buttonTheme") : depth0), depth0))
    + "\"> <p class=\"expand\">Read More</p> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"plus","expand",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":210},"end":{"line":1,"column":237}}}))
    + " <p class=\"collapse\">Read Less</p> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias1,"minus","collapse",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":272},"end":{"line":1,"column":302}}}))
    + " </a>";
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=Collapsible.js.map